import React from 'react'

interface PageHeaderProps {
  title: string
  description?: string
  actions?: React.ReactNode
  /**
   * Optional content rendered inline to the right of the title. Used for
   * small status indicators (e.g. SearchHealthBadge) that should sit next
   * to the page name rather than below it.
   */
  titleAccessory?: React.ReactNode
}

export const PageHeader = ({
  title,
  description,
  actions,
  titleAccessory,
}: PageHeaderProps): JSX.Element => {
  return (
    <div className="flex flex-col gap-3 pb-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="space-y-1 min-w-0">
        <div className="flex items-center gap-3 min-w-0">
          <h1 className="text-xl sm:text-2xl font-semibold tracking-tight truncate">{title}</h1>
          {titleAccessory}
        </div>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 sm:shrink-0">{actions}</div>}
    </div>
  )
}
